import type { Ref } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { unref } from 'vue';
import { getApi } from './api';
import type { AccountExceptionMetrics } from './shipment-exception-types';

export type { AccountExceptionMetrics } from './shipment-exception-types';

export default (accountId: Ref<number> | number) => {
  return useQuery({
    queryKey: ['account-exception-metrics', () => unref(accountId)],
    queryFn: async (): Promise<AccountExceptionMetrics> => {
      const { api, baseURL } = getApi();
      const actualAccountId = unref(accountId);
      const res = await api.get(
        `/api/v2/accounts/${actualAccountId}/exceptions/metrics`,
        { baseURL },
      );
      const body = res.data;
      return (body?.data ?? body) as AccountExceptionMetrics;
    },
    enabled: !!unref(accountId),
  });
};
